import Icon from '../components/Icon.vue'

Icon.register({
  wind: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M156.7 256H16C7.2 256 0 263.2 0 272V304C0 312.8 7.2 320 16 320H158.2C174.1 320 189 330.9 191.6 346.6 194.9 366.6 179.5 384 160 384 145.9 384 133.9 374.8 129.6 362.1 127.5 355.8 121 352 114.4 352H81.6C71.8 352 63.9 360.8 65.7 370.4 74.3 414.5 113.3 448 159.9 448 217 448 262.6 397.9 255.1 339.4 249 291 205.4 256 156.7 256zM16 224H352C411.7 224 458.8 169.2 445.8 107.3 438.2 71.1 408.9 41.8 372.7 34.2 317.3 22.6 267.6 59.1 257.8 109.7 255.9 119.3 263.9 128 273.6 128H306.4C313.1 128 319.5 124.2 321.6 117.9 325.9 105.2 337.9 96 352 96 371.4 96 386.9 113.4 383.6 133.4 381 149.1 366.2 160 350.2 160H16C7.2 160 0 167.2 0 176V208C0 216.8 7.2 224 16 224zM400 256H243.7C263 272.6 276.9 294.8 283.5 320H400C426.5 320 448 341.5 448 368S426.5 416 400 416C382.1 416 366.7 406.1 358.4 391.6 355.5 386.6 349.7 384 343.9 384H310.1C299.2 384 291.1 394.8 294.8 405.1 312.6 455.7 365.3 489.9 424.2 477.4 465.4 468.7 499.3 435.8 508.9 394.7 526 321.5 470.5 256 400 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wind.js
// module id = 1VfI
// module chunks = 144